import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import Breadcrumb from '../common/Breadcrumb'
import WrappedTabs from '../common/WrappedTabs'
import './branches-management.scss'
import Branches from './Branches'
import Requests from './Requests'

const BranchesManagement = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(null)
  const tabs = [
    {
      key: 0,
      title: 'organization_context.branches',
      content: <Branches />,
    },
    {
      key: 1,
      title: 'dealer-portal.requests',
      content: <Requests />,
    },
  ]

  useEffect(() => {
    setActiveTab(tabs[0])
  }, [])

  const handleChangeTab = (tabKey) => {
    const tab = tabs.find((tab) => tab.key === tabKey)
    setActiveTab(tab)
  }

  return (
    <div className="branches-management-wrapper">
      <Breadcrumb path={window.location.pathname} />
      <DashboardHeader headerText={t('nav.branches_management')} />
      <WrappedTabs tabs={tabs.map((tab) => ({ id: tab.key, name: tab.title }))} activeTab={activeTab?.key} changeTab={handleChangeTab} />
      {activeTab?.content && activeTab.content}
    </div>
  )
}

export default BranchesManagement
